<template lang="html">
  <div v-if="loading" class="loading-page">
    <div class="container-loading">
      <div class="progress-loading" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      loading : false,
      size    : '75px'
    };
  },
  computed: {
    ...mapState({
      loadingColor: state => state.application.themes.loadingColor
    })
  },
  methods: {
    start() {
      this.loading = true;
    },
    finish() {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
  .loading-page {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    text-align: center;
    padding-top: 200px;
    font-size: 30px;
    font-family: sans-serif;
    z-index: 1000
  }
  .container-loading{
    position: fixed;
    width: 100%;
    height: 3px;
    left: 0;
    top: 0;
    background-color: var(--v-primary-lighten5) !important;
    -webkit-box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.2) !important;
    -moz-box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.2) !important;
    box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.2) !important;
  }
  .progress-loading{
    width: 40%;
    height: 3px;
    position: absolute;
    left: 0;
    top: 0;
    background-color: var(--v-primary-base) !important;
    animation-name: progress-animation;
    animation-duration: 1s;
    animation-iteration-count: infinite;
  }
  @keyframes progress-animation {
    0%   {left: 0; width: 40%;}
    100%  {left: 100%; width: 10%;}
  }
</style>
